var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordChanged(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 56,
    viewBox: "0 0 94 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-368 -296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443,339H373a4,4,0,0,1-4-4V305a4,4,0,0,1,4-4h70",
    transform: "translate(0 4)",
    fill: "#fff",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,306v10l8-4",
    transform: "translate(8 9)",
    fill: "none",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 8,
    y2: 4,
    transform: "translate(377 321)",
    fill: "none",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,317l-6-6-6,6",
    transform: "translate(5 14)",
    fill: "none",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,306v10l8-4",
    transform: "translate(19 9)",
    fill: "none",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 8,
    y2: 4,
    transform: "translate(399 321)",
    fill: "none",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,317l-6-6-6,6",
    transform: "translate(16 14)",
    fill: "none",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,306v10l8-4",
    transform: "translate(30 9)",
    fill: "none",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 8,
    y2: 4,
    transform: "translate(421 321)",
    fill: "none",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,317l-6-6-6,6",
    transform: "translate(27 14)",
    fill: "none",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,301h6a4,4,0,0,1,4,4v30a4,4,0,0,1-4,4h-6",
    transform: "translate(41 4)",
    fill: "#fff",
    stroke: "#02022c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 54,
    transform: "translate(447 297)",
    fill: "none",
    stroke: "#0055FF",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 12,
    transform: "translate(441 351)",
    fill: "none",
    stroke: "#0055FF",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 12,
    transform: "translate(441 297)",
    fill: "none",
    stroke: "#0055FF",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordChanged);
export default __webpack_public_path__ + "static/media/password-changed.ad1a31642a2711587bcfa33ac2e9acab.svg";
export { ForwardRef as ReactComponent };